import fetchApi from "../fetchApi";
export const CheckCardBalance = async (
    {prn}
   ) => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/cardholder/${prn}/balance`, options);
};